import React, { useEffect, useState } from "react";

// import { loginUser, loginUserReq } from "../../../redux/ActionCreators";
import { useDispatch, useSelector } from "react-redux";
import adminAction from "../../../redux/admin/action";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../../../api";

export function NavbarAdmin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setAdmin } = adminAction;
  const adminStore = useSelector((state) => state.adminReducer);
  const notificationStore = useSelector((state) => state.notificationReducer);

  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const logout = () => {
    const res = api.adminLogout();
    console.log(res);

    dispatch(setAdmin({}));
    console.log("remove token");

    localStorage.removeItem("token");
    navigate("/");
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    } else {
      logout();
    }
  }, []);

  const clickNoify = () => {
    if (notificationStore?.notification) {
      navigate("/admin/support");
    }
  };

  return (
    <>
      {/* Topbar */}
      <nav
        className={
          adminStore?.admin?.admin?.role == "sackAdmin755"
            ? "support navbar navbar-expand navbar-light bg-white topbar mb-4 static-top"
            : "navbar navbar-expand navbar-light bg-white topbar mb-4 static-top"
        }
      >
        {/* Sidebar Toggle + Admin label (same row) */}
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link d-md-none px-2"
            onClick={() =>
              document.body.classList.toggle("sidebar-mobile-open")
            }
            style={{ color: "#6c757d", fontSize: 18, minWidth: 36, width: 36 }}
          >
            <i className="fa-solid fa-bars" />
          </button>
          {adminStore?.admin?.admin?.role == "sackAdmin755" && (
            <h6 className="mb-0 ms-1" style={{ fontSize: 13 }}>
              {adminStore?.admin?.admin?.name}:{" "}
              {adminStore?.admin?.admin?.email}
            </h6>
          )}
        </div>
        <div className="walletBtn ms-auto px-3">
          {/* {adminStore?.admin?.admin?.email === "alex@waqarzaka.net" && ( */}
          {adminStore?.admin?.admin?.role == "sackAdmin755" && (
            <span className="notifyMain" onClick={clickNoify}>
              {notificationStore?.notification && (
                <div className="notify"></div>
              )}
              <i className="fa-solid fa-bell"></i>
            </span>
          )}
          <button className="btn" onClick={logout}>
            logout
          </button>
        </div>
      </nav>
      {/* End of Topbar */}
    </>
  );
}
